<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<div class="cssLayoutRowSpaceCenter">
  <div class="exhibit-teams-list-container mat-elevation-z8">
    <div class="sp-icon">
      <b>All Teams</b>
    </div>
    <hr />

    <div>
      <mat-table class="mat-table-exhibit-teams" #table [dataSource]="exhibitTeamDataSource" matSort>
        <ng-container matColumnDef="name">
          <mat-cell *matCellDef="let element">
            @if (element.name !== null) {
            <div>{{ element.shortName }}</div>
            }
            @if (element.name === null) {
            <div>{{ element.id }}</div>
            }
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="id">
          <mat-cell *matCellDef="let element">
            <div class="push-right">
              <button mat-icon-button (click)="addTeamToArticle(element)" style="outline: none;"
                title="Add {{ element.shortName }}" [disabled]="!canEdit">
                <mat-icon class="mdi-24px center-self" fontIcon="mdi-minus-circle-outline"></mat-icon>
              </button>
            </div>
          </mat-cell>
        </ng-container>

        <mat-row *matRowDef="let row; columns: displayedTeamColumns"></mat-row>
      </mat-table>
    </div>
  </div>

  <div class="article-teams-list-container mat-elevation-z8">
    <div class="sp-icon">
      <b>Selected Teams</b>
    </div>
    <hr />
    <mat-table class="mat-table-article-teams" #table [dataSource]="articleTeamDataSource" matSort>
      <ng-container matColumnDef="name">
        <mat-cell *matCellDef="let element">
          @if (element.name !== null) {
          <div>{{ element.shortName }}</div>
          }
          @if (element.name === null) {
          <div>{{ element.id }}</div>
          }
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="id">
        <mat-cell *matCellDef="let element">
          <div class="push-right">
            <button mat-icon-button (click)="removeTeamFromArticle(element)" style="outline: none;"
              title="Remove {{ element.shortName }}" [disabled]="!canEdit">
              <mat-icon class="mdi-24px center-self" fontIcon="mdi-minus-circle-outline"></mat-icon>
            </button>
          </div>
        </mat-cell>
      </ng-container>

      <mat-row *matRowDef="let row; columns: displayedTeamColumns"></mat-row>
    </mat-table>

  </div>
</div>
